import { FilterMultiSelect } from '@pmi/dsm-react';
import { useEffect, useState } from 'react';
import { FilterIcon } from '@pmi/dsm-react/dist/components/icons/fa/16';
import styles from './FilterBy.module.scss';
import FilterCustomSelect from './FilterCustomSelect';

export interface Option {
  label: string;
  value: string;
  disabled?: boolean;
  groupKey?: string;
}

export interface FilterByOptions {
  key: string;
  text: string;
  options: Option[] | { [key: string]: Option[] };
}

export interface FilterBySelectedItems {
  [key: string]: any[];
}

export interface FilterByProps {
  items: FilterByOptions[];
  onChange: (selectedItems: FilterBySelectedItems) => void;
  defaultSelectedItems?: FilterBySelectedItems;
  resetFilter?: boolean;
}

export default function FilterBy({
  items,
  onChange,
  defaultSelectedItems = null,
  resetFilter = false,
}: FilterByProps) {
  const [selectedItems, setSelectedItems] = useState(defaultSelectedItems);
  const setFilterItems = (key: string, elements: any) => {
    const clone = { ...selectedItems };
    clone[key] = elements;
    setSelectedItems(clone);
    onChange(clone);
  };

  const setDefaultSelectedValues = (defaultItems: FilterBySelectedItems) => {
    setSelectedItems(defaultItems);
    onChange(defaultItems);
  };

  const getSelectedItems = (key: string) =>
    selectedItems ? selectedItems[key] ?? [] : [];

  useEffect(() => {
    setDefaultSelectedValues(defaultSelectedItems);
  }, [defaultSelectedItems, resetFilter]);

  useEffect(() => {
    setTimeout(() => {
      const btns = document.querySelectorAll(
        `.${styles.filterBy} button.filter-button.clear`,
      );
      if (btns && btns.length > 0) {
        btns.forEach((el) => {
          const btn = el as HTMLButtonElement;
          btn.innerHTML = 'Clear';
        });
      }
    }, 500);
  }, [items]);
  return (
    <div
      className={`${styles.filterBy} d-block d-sm-flex mb-3 mb-sm-0 filter-group`}
    >
      <div
        className={`${styles.filterText} d-flex align-items-center align-content-center me-3 py-2 py-sm-0`}
      >
        <FilterIcon fontSize="sm" className={`me-1 ${styles.filterText}`} />
        Filter by
      </div>
      {items &&
        items.map((item) => (
          <div
            className={`${styles.filterBySelect}`}
            key={`filter-${item.key}`}
          >
            {Array.isArray(item.options) && (
              <FilterMultiSelect
                label={item.text}
                options={item.options}
                selected={getSelectedItems(item.key)}
                fontWeight="regular"
                onApply={(applyItems: any[]) => {
                  setFilterItems(item.key, applyItems);
                }}
                isFilterForTable
                fontSize="md"
                variant="gray"
                className={null}
              />
            )}
            {!Array.isArray(item.options) && (
              <div className="filter">
                <FilterCustomSelect
                  key={item.key}
                  label={item.text}
                  options={item.options}
                  selected={getSelectedItems(item.key)}
                  onApply={(applyItems: any[]) => {
                    setFilterItems(item.key, applyItems);
                  }}
                />
              </div>
            )}
          </div>
        ))}
    </div>
  );
}
